// Team primary colors based on their kits/branding
// Keys are normalized team names (lowercase, no FC/AFC suffix)

const TEAM_COLORS: Record<string, string> = {
  // Premier League
  'arsenal': '#EF0107',
  'aston villa': '#670E36',
  'bournemouth': '#DA291C',
  'brentford': '#E30613',
  'brighton': '#0057B8',
  'brighton & hove albion': '#0057B8',
  'burnley': '#6C1D45',
  'chelsea': '#034694',
  'crystal palace': '#1B458F',
  'everton': '#003399',
  'fulham': '#FFFFFF',
  'ipswich': '#0044AA',
  'ipswich town': '#0044AA',
  'leeds': '#FFCD00',
  'leeds united': '#FFCD00',
  'leicester': '#003090',
  'leicester city': '#003090',
  'liverpool': '#C8102E',
  'luton': '#F78F1E',
  'luton town': '#F78F1E',
  'manchester city': '#6CABDD',
  'manchester united': '#DA291C',
  'man city': '#6CABDD',
  'man united': '#DA291C',
  'newcastle': '#241F20',
  'newcastle united': '#241F20',
  'nottingham forest': '#DD0000',
  "nott'ham forest": '#DD0000',
  'sheffield united': '#EE2737',
  'sheffield': '#EE2737',
  'southampton': '#D71920',
  'tottenham': '#132257',
  'tottenham hotspur': '#132257',
  'spurs': '#132257',
  'west ham': '#7A263A',
  'west ham united': '#7A263A',
  'wolves': '#FDB913',
  'wolverhampton': '#FDB913',
  'wolverhampton wanderers': '#FDB913',

  // Championship
  'birmingham': '#0000FF',
  'birmingham city': '#0000FF',
  'blackburn': '#009EE0',
  'blackburn rovers': '#009EE0',
  'bristol city': '#E21937',
  'cardiff': '#0070B5',
  'cardiff city': '#0070B5',
  'coventry': '#87CEEB',
  'coventry city': '#87CEEB',
  'derby': '#FFFFFF',
  'derby county': '#FFFFFF',
  'hull': '#F5A12D',
  'hull city': '#F5A12D',
  'middlesbrough': '#E11B22',
  'millwall': '#001D5E',
  'norwich': '#00A650',
  'norwich city': '#00A650',
  'plymouth': '#00483B',
  'plymouth argyle': '#00483B',
  'portsmouth': '#001489',
  'preston': '#FFFFFF',
  'preston north end': '#FFFFFF',
  'qpr': '#1D5BA4',
  'queens park rangers': '#1D5BA4',
  'sheffield wednesday': '#0057B8',
  'stoke': '#E03A3E',
  'stoke city': '#E03A3E',
  'sunderland': '#EB172B',
  'swansea': '#FFFFFF',
  'swansea city': '#FFFFFF',
  'watford': '#FBEE23',
  'west brom': '#122F67',
  'west bromwich': '#122F67',
  'west bromwich albion': '#122F67',

  // League One
  'barnsley': '#E11717',
  'blackpool': '#F68712',
  'bolton': '#0E1E5B',
  'bolton wanderers': '#0E1E5B',
  'bristol rovers': '#0066B3',
  'burton albion': '#FFE600',
  'burton': '#FFE600',
  'cambridge': '#F5A623',
  'cambridge united': '#F5A623',
  'carlisle': '#0066B3',
  'carlisle united': '#0066B3',
  'charlton': '#D4021D',
  'charlton athletic': '#D4021D',
  'cheltenham': '#E30613',
  'cheltenham town': '#E30613',
  'crawley': '#E30613',
  'crawley town': '#E30613',
  'exeter': '#E30613',
  'exeter city': '#E30613',
  'fleetwood': '#E30613',
  'fleetwood town': '#E30613',
  'huddersfield': '#0E63AD',
  'huddersfield town': '#0E63AD',
  'leyton orient': '#E30613',
  'lincoln': '#E30613',
  'lincoln city': '#E30613',
  'mansfield': '#F5A623',
  'mansfield town': '#F5A623',
  'northampton': '#862633',
  'northampton town': '#862633',
  'oxford': '#F5F500',
  'oxford united': '#F5F500',
  'peterborough': '#0066B3',
  'peterborough united': '#0066B3',
  'reading': '#004494',
  'rotherham': '#E30613',
  'rotherham united': '#E30613',
  'shrewsbury': '#0066B3',
  'shrewsbury town': '#0066B3',
  'stevenage': '#E30613',
  'stockport': '#0066B3',
  'stockport county': '#0066B3',
  'wigan': '#1E5AA8',
  'wigan athletic': '#1E5AA8',
  'wrexham': '#E30613',
  'wycombe': '#71B2D0',
  'wycombe wanderers': '#71B2D0',

  // League Two
  'afc wimbledon': '#002D62',
  'wimbledon': '#002D62',
  'accrington': '#E30613',
  'accrington stanley': '#E30613',
  'accrington st': '#E30613',
  'barrow': '#0066B3',
  'bradford': '#862633',
  'bradford city': '#862633',
  'bromley': '#FFFFFF',
  'chelmsford': '#862633',
  'chelmsford city': '#862633',
  'chesterfield': '#0066B3',
  'colchester': '#0066B3',
  'colchester united': '#0066B3',
  'crewe': '#E30613',
  'crewe alexandra': '#E30613',
  'doncaster': '#E30613',
  'doncaster rovers': '#E30613',
  'gillingham': '#0066B3',
  'grimsby': '#000000',
  'grimsby town': '#000000',
  'harrogate': '#F5F500',
  'harrogate town': '#F5F500',
  'mk dons': '#E30613',
  'milton keynes dons': '#E30613',
  'morecambe': '#E30613',
  'newport': '#F5A623',
  'newport county': '#F5A623',
  'notts county': '#000000',
  'port vale': '#000000',
  'salford': '#E30613',
  'salford city': '#E30613',
  'sutton': '#F5A623',
  'sutton united': '#F5A623',
  'swindon': '#E30613',
  'swindon town': '#E30613',
  'tranmere': '#FFFFFF',
  'tranmere rovers': '#FFFFFF',
  'walsall': '#E30613',

  // National League (5th tier)
  'aldershot': '#E30613',
  'aldershot town': '#E30613',
  'barnet': '#F5A623',
  'boreham wood': '#FFFFFF',
  'braintree': '#F5A623',
  'braintree town': '#F5A623',
  'dag & red': '#E30613',
  'dagenham': '#E30613',
  'dagenham & redbridge': '#E30613',
  'eastleigh': '#0066B3',
  'ebbsfleet': '#E30613',
  'ebbsfleet united': '#E30613',
  'fc halifax': '#0066B3',
  'fc halifax town': '#0066B3',
  'gateshead': '#FFFFFF',
  'hartlepool': '#0066B3',
  'hartlepool united': '#0066B3',
  'maidenhead': '#000000',
  'maidenhead united': '#000000',
  'oldham': '#0066B3',
  'oldham athletic': '#0066B3',
  'rochdale': '#0066B3',
  'solihull': '#F5F500',
  'solihull moors': '#F5F500',
  'southend': '#0066B3',
  'southend united': '#0066B3',
  'wealdstone': '#0066B3',
  'woking': '#E30613',
  'york': '#E30613',
  'york city': '#E30613',

  // La Liga
  'atletico madrid': '#CB3524',
  'atletico de madrid': '#CB3524',
  'atleti': '#CB3524',
  'athletic bilbao': '#EE2523',
  'athletic club': '#EE2523',
  'barcelona': '#A50044',
  'fc barcelona': '#A50044',
  'barca': '#A50044',
  'real madrid': '#FFFFFF',
  'sevilla': '#F43333',
  'sevilla fc': '#F43333',
  'valencia': '#EE3524',
  'valencia cf': '#EE3524',
  'villarreal': '#FFCD00',
  'villarreal cf': '#FFCD00',
  'real sociedad': '#143C8B',
  'real betis': '#00954C',
  'betis': '#00954C',
  'getafe': '#004FA3',
  'getafe cf': '#004FA3',
  'osasuna': '#D91A21',
  'ca osasuna': '#D91A21',
  'celta vigo': '#8AC3EE',
  'celta': '#8AC3EE',
  'rc celta': '#8AC3EE',
  'mallorca': '#E20613',
  'rcd mallorca': '#E20613',
  'las palmas': '#FFCD00',
  'ud las palmas': '#FFCD00',
  'alaves': '#0056A3',
  'deportivo alaves': '#0056A3',
  'girona': '#CD2534',
  'girona fc': '#CD2534',
  'rayo vallecano': '#E53027',
  'rayo': '#E53027',
  'cadiz': '#FEE800',
  'cadiz cf': '#FEE800',
  'almeria': '#EE1C25',
  'ud almeria': '#EE1C25',
  'espanyol': '#007FC8',
  'rcd espanyol': '#007FC8',
  'leganes': '#003DA5',
  'cd leganes': '#003DA5',
  'real valladolid': '#8E4D94',
  'valladolid': '#8E4D94',

  // Bundesliga
  'bayern munich': '#DC052D',
  'bayern': '#DC052D',
  'borussia dortmund': '#FDE100',
  'dortmund': '#FDE100',
  'rb leipzig': '#DD0741',
  'leipzig': '#DD0741',
  'bayer leverkusen': '#E32221',
  'leverkusen': '#E32221',
  'union berlin': '#EB1923',
  'eintracht frankfurt': '#E1000F',
  'frankfurt': '#E1000F',
  'wolfsburg': '#65B32E',
  'vfl wolfsburg': '#65B32E',
  'freiburg': '#E2001A',
  'sc freiburg': '#E2001A',
  'monchengladbach': '#000000',
  'borussia monchengladbach': '#000000',
  'borussia mönchengladbach': '#000000',
  'gladbach': '#000000',
  'hoffenheim': '#1961B5',
  '1899 hoffenheim': '#1961B5',
  'tsg hoffenheim': '#1961B5',
  'mainz': '#C3141E',
  'fsv mainz': '#C3141E',
  'fsv mainz 05': '#C3141E',
  'augsburg': '#BA3733',
  'fc augsburg': '#BA3733',
  'werder bremen': '#1D9053',
  'bremen': '#1D9053',
  'sv werder bremen': '#1D9053',
  'bochum': '#005BA5',
  'vfl bochum': '#005BA5',
  'koln': '#ED1C24',
  'cologne': '#ED1C24',
  'fc koln': '#ED1C24',
  '1. fc koln': '#ED1C24',
  'heidenheim': '#E30613',
  '1. fc heidenheim': '#E30613',
  'fc heidenheim': '#E30613',
  'darmstadt': '#004A99',
  'sv darmstadt': '#004A99',
  'sv darmstadt 98': '#004A99',
  'stuttgart': '#E32219',
  'vfb stuttgart': '#E32219',
  'st. pauli': '#6D4C3D',
  'fc st. pauli': '#6D4C3D',
  'holstein kiel': '#003E7E',
  'kiel': '#003E7E',

  // Serie A
  'inter': '#0068A8',
  'inter milan': '#0068A8',
  'internazionale': '#0068A8',
  'ac milan': '#FB090B',
  'milan': '#FB090B',
  'juventus': '#FFFFFF',
  'napoli': '#12A0D7',
  'ssc napoli': '#12A0D7',
  'roma': '#8E1F2F',
  'as roma': '#8E1F2F',
  'lazio': '#87D8F7',
  'ss lazio': '#87D8F7',
  'atalanta': '#1E71B8',
  'fiorentina': '#482E92',
  'acf fiorentina': '#482E92',
  'bologna': '#1A2F48',
  'torino': '#8B0000',
  'monza': '#AC1E2D',
  'ac monza': '#AC1E2D',
  'udinese': '#FFFFFF',
  'sassuolo': '#00A651',
  'empoli': '#00529B',
  'cagliari': '#9D2235',
  'verona': '#FFED00',
  'hellas verona': '#FFED00',
  'lecce': '#FFDF00',
  'us lecce': '#FFDF00',
  'genoa': '#A41E22',
  'genoa cfc': '#A41E22',
  'frosinone': '#FFED00',
  'salernitana': '#862633',
  'parma': '#FFED00',
  'parma calcio': '#FFED00',
  'parma calcio 1913': '#FFED00',
  'como': '#003DA5',
  'como 1907': '#003DA5',
  'venezia': '#FFA500',
  'venezia fc': '#FFA500',

  // Ligue 1
  'psg': '#004170',
  'paris saint-germain': '#004170',
  'paris saint germain': '#004170',
  'marseille': '#2FAEE0',
  'olympique marseille': '#2FAEE0',
  'olympique de marseille': '#2FAEE0',
  'om': '#2FAEE0',
  'monaco': '#E7192E',
  'as monaco': '#E7192E',
  'lyon': '#004A8F',
  'olympique lyonnais': '#004A8F',
  'olympique lyon': '#004A8F',
  'ol': '#004A8F',
  'lille': '#E2001A',
  'losc': '#E2001A',
  'losc lille': '#E2001A',
  'lens': '#FFD700',
  'rc lens': '#FFD700',
  'nice': '#E30613',
  'ogc nice': '#E30613',
  'rennes': '#E2001A',
  'stade rennais': '#E2001A',
  'strasbourg': '#009FE3',
  'rc strasbourg': '#009FE3',
  'rc strasbourg alsace': '#009FE3',
  'reims': '#E20714',
  'stade de reims': '#E20714',
  'montpellier': '#004170',
  'montpellier hsc': '#004170',
  'nantes': '#FCDD09',
  'fc nantes': '#FCDD09',
  'toulouse': '#7B3F98',
  'toulouse fc': '#7B3F98',
  'brest': '#E2001A',
  'stade brestois': '#E2001A',
  'stade brestois 29': '#E2001A',
  'lorient': '#F4841F',
  'fc lorient': '#F4841F',
  'le havre': '#00A1DE',
  'le havre ac': '#00A1DE',
  'clermont': '#E30513',
  'clermont foot': '#E30513',
  'metz': '#811330',
  'fc metz': '#811330',
  'saint etienne': '#00A651',
  'saint-etienne': '#00A651',
  'as saint-etienne': '#00A651',
  'asse': '#00A651',
  'auxerre': '#004A8F',
  'aj auxerre': '#004A8F',
  'angers': '#FFFFFF',
  'angers sco': '#FFFFFF',
}

// Normalize team name for lookup
function normalizeTeamName(name: string): string {
  return name
    .toLowerCase()
    // Remove common suffixes
    .replace(/\s*(fc|afc|cf|sc|sv|vfl|vfb|tsg|fsv|1\.|ssc|ss|acf|ac|us|cfc|hsc|sco)\s*$/i, '')
    // Normalize umlauts and special chars
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/ö/g, 'o')
    .replace(/ü/g, 'u')
    .replace(/ä/g, 'a')
    .replace(/ß/g, 'ss')
    .replace(/\s+/g, ' ')
    .trim()
}

// Get team color, with fallback
export function getTeamColor(teamName: string, fallback: string = '#888888'): string {
  const normalized = normalizeTeamName(teamName)

  // Direct match
  if (TEAM_COLORS[normalized]) {
    return TEAM_COLORS[normalized]
  }

  // Try matching with normalized keys
  for (const [key, color] of Object.entries(TEAM_COLORS)) {
    const normalizedKey = normalizeTeamName(key)

    // Direct match with normalized key
    if (normalized === normalizedKey) {
      return color
    }

    // Partial match (team name contains key or key contains team name)
    if (normalized.includes(normalizedKey) || normalizedKey.includes(normalized)) {
      return color
    }
  }

  return fallback
}

// For white/light colored teams, we need to ensure visibility
export function getTeamColorWithContrast(teamName: string, fallback: string = '#888888'): {
  color: string
  needsBorder: boolean
} {
  const color = getTeamColor(teamName, fallback)

  // Check if color is too light (white or near-white)
  const isLight = color.toUpperCase() === '#FFFFFF' ||
                  color.toUpperCase() === '#FFF' ||
                  isLightColor(color)

  return {
    color: isLight ? '#CCCCCC' : color, // Use light grey for white teams
    needsBorder: isLight
  }
}

// Helper to check if a hex color is light
function isLightColor(hex: string): boolean {
  const c = hex.replace('#', '')
  const r = parseInt(c.substr(0, 2), 16)
  const g = parseInt(c.substr(2, 2), 16)
  const b = parseInt(c.substr(4, 2), 16)
  // Using luminance formula
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.85
}

// Generate a contrasting secondary color from the primary
function generateSecondaryColor(primaryHex: string): string {
  const c = primaryHex.replace('#', '')
  const r = parseInt(c.substr(0, 2), 16)
  const g = parseInt(c.substr(2, 2), 16)
  const b = parseInt(c.substr(4, 2), 16)

  // Shift hue by rotating RGB channels and adjusting brightness
  // This creates a distinct but harmonious secondary color
  const avg = (r + g + b) / 3

  // If the color is dark, lighten it; if light, darken it
  const factor = avg < 128 ? 1.4 : 0.6

  // Also shift the hue slightly by rotating emphasis
  const newR = Math.min(255, Math.max(0, Math.round(g * factor + 30)))
  const newG = Math.min(255, Math.max(0, Math.round(b * factor + 30)))
  const newB = Math.min(255, Math.max(0, Math.round(r * factor + 30)))

  return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`
}

// Check if two colors are too similar
function colorsTooSimilar(hex1: string, hex2: string, threshold: number = 60): boolean {
  const c1 = hex1.replace('#', '')
  const c2 = hex2.replace('#', '')

  const r1 = parseInt(c1.substr(0, 2), 16)
  const g1 = parseInt(c1.substr(2, 2), 16)
  const b1 = parseInt(c1.substr(4, 2), 16)

  const r2 = parseInt(c2.substr(0, 2), 16)
  const g2 = parseInt(c2.substr(2, 2), 16)
  const b2 = parseInt(c2.substr(4, 2), 16)

  // Euclidean distance in RGB space
  const distance = Math.sqrt(
    Math.pow(r1 - r2, 2) +
    Math.pow(g1 - g2, 2) +
    Math.pow(b1 - b2, 2)
  )

  return distance < threshold
}

// Get colors for a matchup ensuring contrast between home and away
export function getMatchupColors(
  homeTeamName: string,
  awayTeamName: string
): { homeColor: string; awayColor: string } {
  const homeColorInfo = getTeamColorWithContrast(homeTeamName)
  const awayColorInfo = getTeamColorWithContrast(awayTeamName)

  let homeColor = homeColorInfo.color
  let awayColor = awayColorInfo.color

  // If colors are too similar, use a generated secondary for the away team
  if (colorsTooSimilar(homeColor, awayColor)) {
    awayColor = generateSecondaryColor(awayColor)

    // If still too similar, use a default contrasting color
    if (colorsTooSimilar(homeColor, awayColor)) {
      // Use a teal/cyan for away if home is red-ish, or orange if home is blue-ish
      const c = homeColor.replace('#', '')
      const r = parseInt(c.substr(0, 2), 16)
      const b = parseInt(c.substr(4, 2), 16)

      if (r > b) {
        awayColor = '#17a2b8' // Teal
      } else {
        awayColor = '#fd7e14' // Orange
      }
    }
  }

  return { homeColor, awayColor }
}
